import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Monkey-patch ResizeObserver to prevent "ResizeObserver loop completed with
// undelivered notifications" errors. Radix UI (Shadcn Select/Popover) triggers
// this benign warning which CRA's react-error-overlay treats as fatal.
// Wrapping callbacks in requestAnimationFrame defers delivery and silences it.
const NativeResizeObserver = window.ResizeObserver;
window.ResizeObserver = class PatchedResizeObserver extends NativeResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
